import { Button, Dialog } from '@material-ui/core';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { OTP_ACTIONS } from '../../../../utils/constants';
import { CommercialRootPath } from '../routeConfig';
import { EMandatePaths, OTMCancelRequestType } from './types';

export const OTMCancelButton = ({ row }: { row: any }) => {
    const [showDialog, setShowDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();

    const showPopup = () => {
        setShowDialog(true);
    }

    const closePopup = () => {
        setShowDialog(false);
    };

    const callOTMCancelApi = async () => {
        const otmApiRequest: OTMCancelRequestType = {
            data: [
                {
                    amc: row.otmAmc,
                    omUmrn: row.omUMRN,
                    maxAmount: row.maxAmount,
                    otmType: row.otmType,
                    payoutMech: row.payoutMech,
                    itemNo: row.itemNo,
                    rtaName: row.rtaName,
                    mandateRefId: row.payoutRefNo,
                },
            ],
        };
        try {
            setLoading(true);
            closePopup();
            const otpPayload = {
                action: OTP_ACTIONS.otmCancel,
            };
            const otpRes = await sendPhoneOTP(otpPayload)(dispatch);
            history.push(`${CommercialRootPath}${EMandatePaths.OtmCancelOTP}`, {
                reqId: otpRes.body.reqId,
                otpRef: otpRes.body.otpRef,
                apiPayload: otmApiRequest
            })
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SubmitButtonWithLoader
                className="customBtn cancelBtn"
                data-testid="sip-button"
                loading={loading}
                onClick={showPopup}
                style={{
                    fontSize: 15,
                    top: '5px',
                    width: '90px',
                    height: '35px',
                }}
                label="Cancel"
            />
            <OTMCancelPopUp
                open={showDialog}
                closePopup={closePopup}
                callOTMCancelApi={callOTMCancelApi}
            />
        </>
    );
};

const OTMCancelPopUp = ({
    open,
    closePopup,
    callOTMCancelApi,
}: {
    open: boolean;
    closePopup: any;
    callOTMCancelApi: () => Promise<void>;
}) => {
    return (
        <Dialog maxWidth={'sm'} open={open} aria-labelledby="note-modals">
            <div className="note-modals">
                <h3> OTM Cancellation </h3>
                <p>Are you sure, you want to cancel?</p>
                <div className="note-modals-btns">
                    <Button onClick={callOTMCancelApi} className="customBtn">Yes</Button>
                    <Button onClick={closePopup} className="customBtn cancelBtn">
                        No
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
